<template>
  <div class="serviceAgreement">
    <div class="main">
      <h2>大救星健康版服务协议</h2>
      <p style="background:#FDFDFE;">
        一、服务提供
      </p>
      <p style="background:#FDFDFE;">
        “大救星”救援服务平台（江泰救援服务有限公司服务平台，<a>以下简称<span>“</span>大救星<span>”）</span></a>通过大救星健康版平台（包括但不限于<span>APP</span>、官网、<span>M</span>站、小程序等互联网端口）向用户提供相关的救援服务。本协议旨在明确双方在使用大救星健康版平台服务过程中的权利与义务。
      </p>
      <p style="background:#FDFDFE;">
        二、用户注册
      </p>
      <p style="background:#FDFDFE;">
        用户需按照大救星健康版平台的提示完成注册流程，成为大救星的注册用户。注册过程中，用户需提供有效的手机号码及密码，用于创建大救星账户。
      </p>
      <p style="background:#FDFDFE;">
        三、服务使用
      </p>
      <p style="background:#FDFDFE;">
        用户有权使用大救星健康版平台提供的各项服务，包括但不限于在线发起救援服务、查看个人服务权益和保障等。用户应遵守平台的使用规则，不得进行任何违法、违规或损害他人权益的行为。
      </p>
      <p style="background:#FDFDFE;">
        四、服务费用
      </p>
      <p style="background:#FDFDFE;">
        用户在使用大救星健康版平台提供的部分服务时，可能需要支付相应的费用。具体费用及支付方式将在平台上进行公示，用户应按照平台的规定进行支付。
      </p>
      <p style="background:#FDFDFE;">
        五、用户信息的真实性
      </p>
      <p style="background:#FDFDFE;">
        用户应保证提供的信息真实、准确、完整，如有变更应及时更新。如因用户提供的信息不真实、不准确或不完整而导致的任何后果，由用户自行承担。
      </p>
      <p style="background:#FDFDFE;">
        六、免责条款
      </p>
      <p style="background:#FDFDFE;">
        大救星在提供服务过程中，对于因不可抗力或第三方原因导致的服务中断、延迟或数据丢失等，不承担任何责任。同时，对于用户在使用服务过程中因个人原因造成的损失，大救星亦不承担责任。
      </p>
      <p style="background:#FDFDFE;">
        七、争议解决
      </p>
      <p style="background:#FDFDFE;">
        如双方在使用大救星健康版平台服务过程中发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向大救星所在地的人民法院提起诉讼。
      </p>
      <p style="background:#FDFDFE;">
        八、其他
      </p>
      <p class="MsoNormal" style="background:#FDFDFE;">
        本协议自用户点击同意之日起生效，并对用户具有法律约束力。本协议的解释、修改权归大救星所有，修改后的协议将通过平台公示的方式通知用户。<span></span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'serviceAgreement',
  data() {
    return {}
  },
  mounted() {
    document.title = '服务协议'
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: transparent !important; /* 设置滚动条追踪区的背景色为透明 */
}
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.serviceAgreement {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  .main {
    width: 100%;
    flex: 1;
    height: auto;
    overflow-y: scroll;
    padding: 3.15vh 4vw;
    h2 {
      font-size: 4vw;
      text-align: center;
      margin-bottom: 2vw;
    }
    h3,
    p {
      font-size: 3.5vw;
      line-height: 6vw;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/serviceAgreement.vue